module.exports = __webpack_public_path__ + "04_long_brown.599d7c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_long_brown.png
// module id = Qb1P
// module chunks = 0